import React, { memo, useMemo, useEffect, useRef, useContext } from "react";
import { message } from "antd";
// import { clipboard } from 'electron';
import { ToolFnContext } from "../../utils/context";

import locale from "../../locale";

import "./index.less";

const Content = ({ idClient, content }) => {
  const contentRef = useRef<any>();
  const { marked } = useContext(ToolFnContext);

  const markdownHtml = useMemo(() => {
    let mdContent = content?.contentPc || "";
    return marked(mdContent);
  }, [content?.contentPc]);

  useEffect(() => {
    const contentElement = contentRef.current;
    if (!contentElement) return;
    contentElement.addEventListener("click", handleClick);

    return () => {
      contentElement.removeEventListener("click", handleClick);
    };
  }, []);

  const handleClick = (event) => {
    const target = event.target;
    const parent = target?.parentElement;

    if (parent?.classList?.contains("hljs-copy")) {
      event.stopPropagation();
      const ancestorsEle = target?.parentElement?.parentElement?.parentElement;
      const targetClassName = "hljs";
      let targetNode: any;

      // 遍历父节点的直接子节点
      if (ancestorsEle?.children?.length) {
        for (const child of ancestorsEle.children) {
          console.log(child.classList);
          if (child.classList.contains(targetClassName)) {
            targetNode = child;
            break; // 如果找到了目标节点，终止循环
          }
        }
      }

      if (targetNode) {
        const code = targetNode.innerText;
        // clipboard.writeText(code);
        message.success(locale("copy_success"));
        return;
      }
    }
  };

  return (
    <div
      ref={contentRef}
      id={`${idClient}-markdown-content`}
      className={"sscard_content"}
      dangerouslySetInnerHTML={{ __html: markdownHtml }}
    />
  );
};

export default memo(Content);
